<template>
  <footer>
    <p>
      <span style="color: rgba(255, 255, 255, 0.6)">{{ nameLine }}</span>
      <span style="margin: 0 0.5rem; color: rgba(255, 255, 255, 0.2)">•</span>
      {{ titleLine }}
    </p>

    <nav class="footer-legal" aria-label="روابط الموقع">
      <template v-for="(link, i) in legalLinks" :key="i">
        <router-link :to="link.link">{{ link.label }}</router-link>
        <span v-if="i < legalLinks.length - 1" class="footer-legal-sep">•</span>
      </template>
    </nav>

    <div class="d-flex align-items-center gap-3">
      <p>{{ creditText }}</p>
      <ul class="social">
        <li v-for="(item, i) in socials" :key="i">
          <a :href="item.url" target="_blank" :aria-label="socialAriaLabel(item.icon)">
            <i :class="`pi pi-${item.icon}`"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
import { computed } from "vue";
import { useHomepageConfig } from "@/composables/useHomepageConfig";

const DEFAULT_FOOTER_SETTINGS = {
  name_line: "أ/ طارق عبدالغني عبدالباري",
  title_line: "مدرس الرياضيات",
  legal_links: [
    { label: 'من نحن', link: '/about' },
    { label: 'المدونة', link: '/blogs' },
    { label: 'سياسة الخصوصية', link: '/privacy-policy' },
    { label: 'شروط الاستخدام', link: '/terms-of-service' },
  ],
  credit_text: 'Powered by Ahmed Hawam ⚡',
  socials: [
    { icon: 'facebook', url: 'https://facebook.com/ahmedhawam2030' },
    { icon: 'whatsapp', url: 'https://wa.me/+201280194879' },
    { icon: 'phone', url: 'tel:01280194879' },
  ],
};

const SOCIAL_ICON_LABEL = { facebook: 'Facebook', whatsapp: 'WhatsApp', phone: 'Phone' };

export default {
  name: "AppFooter",
  setup() {
    // Homepage Builder feature — global footer chrome. Self-fetched here
    // (not passed down from App.vue) — the composable's module-level cache
    // dedupes this with navbar's/HomePageRenderer's own fetchHomepageConfig()
    // calls into a single network request.
    const { getSettings, fetchHomepageConfig } = useHomepageConfig();
    fetchHomepageConfig();
    const settings = computed(() => getSettings('footer', DEFAULT_FOOTER_SETTINGS));
    const nameLine = computed(() => settings.value.name_line);
    const titleLine = computed(() => settings.value.title_line);
    const creditText = computed(() => settings.value.credit_text);
    const legalLinks = computed(() => settings.value.legal_links);
    const socials = computed(() => settings.value.socials);
    return { nameLine, titleLine, creditText, legalLinks, socials };
  },
  methods: {
    socialAriaLabel(icon) {
      return SOCIAL_ICON_LABEL[icon] || icon;
    },
  },
};
</script>

<style scoped>
.footer-legal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  font-family: 'Cairo', sans-serif;
  font-size: 0.85rem;
}
.footer-legal a {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  font-weight: 700;
  transition: color 0.2s;
}
.footer-legal a:hover { color: #fff; }
.footer-legal-sep { color: rgba(255, 255, 255, 0.25); }
</style>
